import { useSelector } from "react-redux";
import { LeftNavBar } from "../../SharedModule/components/LeftNavBar";
import { LeftNavBarSection } from "../../SharedModule/components/LeftNavBarSection";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";
import {
  CLIENTS_VIEWER_ACCESS,
  ROUTE_CLIENTS,
  ROUTE_CLIENTS_RELATIONSHIP_REVIEW,
  ROUTE_CLIENTS_REPORTS,
} from "../../SharedModule/utils/constants";

export const LeftNavBarClients = (props: any) => {
  const { userRolesList } = useSelector(selectUserRoles);

  return (
    <LeftNavBar>
      <LeftNavBarSection
        mainTitle="Clients"
        biIconName="BiUserPin"
        requireModuleAccess={false}
        listOfLinks={[
          {
            text: "Client List",
            route: ROUTE_CLIENTS,
            requireModuleAccess: false,
          },
        ]}
      />
      <LeftNavBarSection
        mainTitle="Reports"
        biIconName="BiBarChartAlt2"
        requireModuleAccess={false}
        actualUserRoles={userRolesList}
        listOfLinks={[
          {
            text: "Client Reports",
            route: ROUTE_CLIENTS_REPORTS,
          },
          {
            text: "Relationship Reviews",
            route: ROUTE_CLIENTS_RELATIONSHIP_REVIEW,
          },
          {
            text: "Commissions Report",
            route: process.env.REACT_APP_ASUITE_BUS_DEV_COMMISSION_REPORT_LINK,
            requireModuleAccess: true,
            roleRequired: CLIENTS_VIEWER_ACCESS,
            newTab: true,
          },
        ]}
      />
    </LeftNavBar>
  );
};
